"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortOrderModifiers = void 0;
const immer_1 = require("immer");
const APPLY_TO_SCORE_MAP = {
    PRODUCT: 0,
    SHIPPING: 100,
    ALL: 200,
};
const TYPE_SCORE_MAP = {
    COMBORULE: 0,
    MERCHANT: 0,
    SURCHARGE: 1,
    SHIPPING_DISCOUNT: 2,
    DISCOUNT: 3,
    PROMOCODE: 4,
    RICECOIN: 5,
};
function sortOrderModifiers(modifiers = []) {
    return (0, immer_1.produce)(modifiers, draftModifiers => {
        return draftModifiers.sort((a, b) => {
            var _a, _b, _c, _d;
            const iScore = ((_a = APPLY_TO_SCORE_MAP[a.applyTo]) !== null && _a !== void 0 ? _a : 0) + ((_b = TYPE_SCORE_MAP[a.type]) !== null && _b !== void 0 ? _b : 0);
            const jScore = ((_c = APPLY_TO_SCORE_MAP[b.applyTo]) !== null && _c !== void 0 ? _c : 0) + ((_d = TYPE_SCORE_MAP[b.type]) !== null && _d !== void 0 ? _d : 0);
            return iScore > jScore ? 1 : -1;
        });
    });
}
exports.sortOrderModifiers = sortOrderModifiers;
//# sourceMappingURL=sortOrderModifiers.js.map